module.exports = __webpack_public_path__ + "img/page-062.439969cf.jpg";